var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "time"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    width: 15,
    height: 15,
    transform: "translate(0 -0.31)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_18",
    "data-name": "Mask Group 18",
    transform: "translate(0 0.31)",
    clipPath: "url(#time)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_26_",
    "data-name": "svgexport-6 (26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5157",
    "data-name": "Path 5157",
    d: "M8.045.545a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Zm0,13.636a6.136,6.136,0,1,1,6.136-6.136A6.136,6.136,0,0,1,8.045,14.182Z",
    transform: "translate(-0.545 -0.545)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5158",
    "data-name": "Path 5158",
    d: "M7.364,7.218V3.409A.682.682,0,0,0,6,3.409V7.5a.682.682,0,0,0,.2.482l2.046,2.046a.682.682,0,1,0,.964-.964Z",
    transform: "translate(0.818 0)",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.64731bf3b06506255a1e14313e508292.svg";
export { ForwardRef as ReactComponent };